import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies';
import { i18n } from './i18n/i18n';
import '@/utils/rem.js';

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tailwind.css'
import './assets/css/product_set.scss'
import './assets/css/problem_set.scss'

Vue.use(ElementUI, { size: 'small', zIndex: 3000 }); // 声明使用ElementUI
Vue.prototype.$vueCookies = VueCookies;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
